import axios from "axios";
import { saveAs } from "file-saver";
import { urtoast } from "../../Layouts/CustomPopup/eventEmitter";

const DownloadAllFilesDirecty = async (filePath) => {
  if (!filePath) {
    urtoast("File path is undefined", 2);
    return;
  }
  try {
    // const url = `http://35.154.56.197/urxprt_formatted/web/download.php?path=${filePath}`;
    const url = `${process.env.REACT_APP_DOWNLOAD_BASEURL}?path=${filePath}`;
    const response = await axios.get(url, { responseType: "blob" });
    if (!response?.data) {
      urtoast("File download failed", 2);
      return;
    }
    const fileName = filePath.split('/').pop().split('?')[0];
    saveAs(response.data, fileName);
    urtoast(`File downloaded successfully`, 1);

  } catch (err) {
    let errorMessage = "Something went wrong while downloading the file";

    if (err?.response) {
      errorMessage = `Download failed: Server error`;
    } else if (err?.request) {
      errorMessage = "Network error: Unable to connect to server";
    } else if (err?.message) {
      errorMessage = `Download error`;
    }

    urtoast(errorMessage, 2);
  }
};

export default DownloadAllFilesDirecty;